import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

const CITE_RE = /\[(\d+)\]/g;

export const Cited = ({ text }) => {
  const parts = [];
  let last = 0;
  for (const m of (text || "").matchAll(CITE_RE)) {
    parts.push(text.slice(last, m.index));
    parts.push(
      <a key={`${m.index}-${m[1]}`} href={`#ref-${m[1]}`} className="relative -top-[0.35em] inline-flex items-center min-h-[24px] px-0.5 text-[0.7em] leading-none text-[#8C7B6B] font-semibold no-underline hover:underline align-baseline" data-testid={`guide-cite-${m[1]}`}>[{m[1]}]</a>
    );
    last = m.index + m[0].length;
  }
  parts.push((text || "").slice(last));
  return <>{parts}</>;
};

export const Paragraphs = ({ text, className = "" }) =>
  (text || "").split("\n").filter((p) => p.trim()).map((p, i) => (
    <p key={`${i}-${p.slice(0, 24)}`} className={`text-base leading-relaxed text-[#3D3833] ${className}`}>
      <Cited text={p} />
    </p>
  ));

export const SectionHeading = ({ id, children }) => (
  <div className="flex items-center gap-3 mb-5 scroll-mt-36 lg:scroll-mt-28" id={id}>
    <h2 className="font-display text-base sm:text-lg uppercase tracking-wide text-[#1A1A1A]">{children}</h2>
    <div className="flex-1 h-px bg-[#DDD7CF]" />
  </div>
);

export const ShopBox = ({ peptide, products, compact = false }) => {
  if (!products?.length) return null;
  return (
    <div className={`border border-[#8C7B6B]/40 rounded-lg bg-white ${compact ? "p-5" : "p-6"}`} data-testid="guide-shop-box">
      <p className="text-[10px] tracking-[0.25em] uppercase font-semibold text-[#8C7B6B] flex items-center gap-2">
        <ShoppingBag className="w-3.5 h-3.5" /> Shop {peptide}
      </p>
      <p className="text-xs text-[#6E675F] mt-1.5">Third-party tested · ships within Canada · research use only</p>
      <div className="mt-4 space-y-2">
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            data-testid={`guide-shop-link-${p.id}`}
            className="group flex items-center gap-3 border border-[#DDD7CF] rounded-md px-3 py-2.5 hover:border-[#8C7B6B] hover:bg-[#F7F5F2] transition-colors"
          >
            {p.image_url && <img src={p.image_url} alt="" className="w-10 h-10 rounded object-cover shrink-0" />}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-[#1A1A1A] truncate">{p.name}{p.dosage ? ` · ${p.dosage}` : ""}</p>
              <p className="text-xs text-[#6E675F]">{p.in_stock ? "In stock" : "Out of stock"}</p>
            </div>
            <span className="text-sm font-medium text-[#1A1A1A] shrink-0">${p.price.toFixed(2)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};
